import { useCallback, useState } from 'react';
import { useAuth } from 'react-oidc-context';
import { cognitoLogoutParams } from './cognitoLogout';

/**
 * Signs out of Cognito itself, not just the local copy of the session, and
 * comes back to the app's own sign-in page. The app's origin must be listed
 * as a sign-out URL on the Cognito app client, or Cognito stops on a
 * `redirect_mismatch` page.
 */
export const useSignOut = () => {
  const auth = useAuth();
  const [signingOut, setSigningOut] = useState(false);

  const signOut = useCallback(async () => {
    setSigningOut(true);
    try {
      // Only the parameters Cognito's /logout actually reads. Spreading the
      // whole auth config here put the client secret in the URL.
      await auth.signoutRedirect({
        extraQueryParams: cognitoLogoutParams(
          auth.settings,
          auth.settings.post_logout_redirect_uri
        ),
      });
    } catch (error) {
      console.error('Sign-out failed, signing out locally:', error);
      // Still end the session here; the sign-in page takes over.
      await auth.removeUser().catch((fallbackError) => {
        console.error('Failed to clear the session:', fallbackError);
      });
      setSigningOut(false);
    }
  }, [auth]);

  return { signOut, signingOut };
};
